<template>
  <div>
    <connection-step :model="model" />
    <mapping-step :model="model"></mapping-step>
    <events-step :model="model" />
  </div>
</template>

<script>
import ConnectionStep from '@/modules/integrations/types/shopify/ConnectionStep'
import EventsStep from '@/modules/integrations/types/shopify/EventsStep'
import MappingStep from '@/modules/integrations/types/shopify/MappingStep'

export default {
  name: 'ShopifySettings',
  components: {
    EventsStep,
    ConnectionStep,
    MappingStep
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/shopify/ShopifySettings.vue